import type { GetMeUserResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { profileKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetUser(userId: string) {
  const query = useQuery<GetMeUserResponse>({
    queryFn: () => apiClient.url(`/users/${userId}`).get().json(),
    queryKey: profileKeys.userById(userId),
  });

  const currentProject = query.data?.projects.find(
    (project) => project.id === query.data.currentProjectId,
  );

  return {
    ...query,
    currentProject,
    websiteUrl: query.data?.websiteUrl,
  };
}
